import { css } from 'lit';

export const style = css`
  h2 {
    font-family: Optimist, 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
    font-size: 1em;
    font-weight: 300;
    margin-bottom: 3em;
    text-align: center;
  }

  .refinance-button-container {
    margin-bottom: 1.5em;
  }

  .container {
    margin-left: 1.5em;
    margin-right: 1.5em;
  }
`;
